import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import MapButton from 'www/vue_components/desktop/CommonFilters/MapButton.vue'
import ServiceFilters from './ServiceFilters.vue'
import ServiceFiltersPageManager from './ServiceFiltersPageManager.vue'

const mountElement = document.querySelector('.service-filters')

if (mountElement) {
  new Vue({
    vuetify,
    el: mountElement,
    components: {
      ServiceFilters,
      ServiceFiltersPageManager,
      MapButton,
    },
  })
}
